export var getIsObjectEmpty = function getIsObjectEmpty(object) {
  var objectKeys = Object.keys(object);
  return objectKeys.length === 0 || objectKeys.every(function (key) {
    return object[key] === null;
  });
};